import {
    setCookie,
    getCookie,
    initializeMap,
    initMenuTrigger,
    initOpenInNewTab,
    //aosConfig,
    addScollClass,
    addFancyboxFixForGallery,
    initGallerySlider,
    addCloseCookies,
    initForm,
    googleMapInit,
    initLoadNews,
    faqService,
    initLazyBg,
    initShow
} from './functions';


import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);


function smoothScroll(content, viewport, smoothness) {
    content = gsap.utils.toArray(content)[0];
    smoothness = smoothness || 1;

    gsap.set(viewport || content.parentNode, { overflow: "hidden", position: "fixed", height: "100%", width: "100%", top: 0, left: 0, right: 0, bottom: 0 });
    gsap.set(content, { overflow: "visible", width: "100%" });

    let getProp = gsap.getProperty(content),
        setProp = gsap.quickSetter(content, "y", "px"),
        setScroll = ScrollTrigger.getScrollFunc(window),
        removeScroll = () => content.style.overflow = "visible",
        killScrub = trigger => {
            let scrub = trigger.getTween ? trigger.getTween() : gsap.getTweensOf(trigger.animation)[0]; // getTween() was added in 3.6.2
            scrub && scrub.pause();
            trigger.animation.progress(trigger.progress);
        },
        height, isProxyScrolling;

    function refreshHeight() {
        height = content.clientHeight;
        content.style.overflow = "visible"
        document.body.style.height = height + "px";
        return height - document.documentElement.clientHeight;
    }

    ScrollTrigger.addEventListener("refresh", () => {
        removeScroll();
        requestAnimationFrame(removeScroll);
    })
    ScrollTrigger.defaults({ scroller: content });
    ScrollTrigger.prototype.update = p => p; // works around an issue in ScrollTrigger 3.6.1 and earlier (fixed in 3.6.2, so this line could be deleted if you're using 3.6.2 or later)

    ScrollTrigger.scrollerProxy(content, {
        scrollTop(value) {
            if (arguments.length) {
                isProxyScrolling = true; // otherwise, if snapping was applied (or anything that attempted to SET the scroll proxy's scroll position), we'd set the scroll here which would then (on the next tick) update the content tween/ScrollTrigger which would try to smoothly animate to that new value, thus the scrub tween would impede the progress. So we use this flag to respond accordingly in the ScrollTrigger's onUpdate and effectively force the scrub to its end immediately.
                setProp(-value);
                setScroll(value);
                return;
            }
            return -getProp("y");
        },
        scrollHeight: () => document.body.scrollHeight,
        getBoundingClientRect() {
            return { top: 0, left: 0, width: window.innerWidth, height: window.innerHeight };
        }
    });

    return ScrollTrigger.create({
        animation: gsap.fromTo(content, { y: 0 }, {
            y: () => document.documentElement.clientHeight - height,
            ease: "none",
            onUpdate: ScrollTrigger.update
        }),
        scroller: window,
        invalidateOnRefresh: true,
        start: 0,
        end: refreshHeight,
        refreshPriority: -999,
        scrub: smoothness,
        onUpdate: self => {
            if (isProxyScrolling) {
                killScrub(self);
                isProxyScrolling = false;
            }
        },
        onRefresh: killScrub // when the screen resizes, we just want the animation to immediately go to the appropriate spot rather than animating there, so basically kill the scrub.
    });
}

var scrollObject;


function isTouchDevice() {
    return (('ontouchstart' in window) ||
        (navigator.maxTouchPoints > 0) ||
        (navigator.msMaxTouchPoints > 0));
}

const mainApp = () => {

    // init lazy loading backgrounds width .lazyBg
    initLazyBg();

    initShow();

    // init menu trigger
    initMenuTrigger();

    // init open in new tab
    initOpenInNewTab();

    // init AOS animation config
    // aosConfig();

    // add scroll class to body  
    if (isTouchDevice())
        addScollClass('30px', 'scroll');
    else
        addScollClass('60px', 'scroll');



    //fix gallery id for slideshow
    addFancyboxFixForGallery('.wp-block-gallery');

    //gallerySlider
    initGallerySlider();

    // add close function to cookies
    addCloseCookies();



    //start - contact form
    initForm();

    googleMapInit();


    initLoadNews();

    faqService();




}

document.addEventListener("DOMContentLoaded", mainApp, false);


(function ($) {
    const mainAppWithJquery = () => {

        if ($('.intro').length > 0 && !getCookie('introShow2')) {


            const intro = gsap.timeline();
            $('.intro').css('opacity', 1);
            $('.intro__svg').css({ 'opacity': 1, 'visibility': 'visible' });

            intro.to('.intro__svg .v1, .intro__svg .v2', {
                opacity: 1,
                y: 0,
                delay: 0.5,
                duration: 1,
                ease: "power1.out"
            });
            intro.to('.intro__svg .v3', {
                opacity: 1,
                delay: -0.7,
                duration: 0.5,
                ease: "power1.in"
            });
            intro.to(' .intro__svg .logistics, .intro__svg .line, .intro__svg .r', {
                opacity: 1,
                // x: 0,
                delay: -0.2,
                duration: 1,
                stagger: 0.2,
                ease: "power2.inOut"
            });
            /*   intro.to('.intro__svg .r', {
                   opacity: 1,
                   //delay: -0.3,
                   duration: 0.5,
                   ease: "power1.out"
               });*/

            intro.to('.intro__svg', {
                //  y: 30,
                opacity: 0,
                duration: 0.8,
                delay: 0.5,
                ease: "power1.out",

            });

            intro.to('.intro', {
                duration: 1, opacity: 0, delay: 0.4, onComplete: function () {
                    setCookie('introShow2', 1, 360);
                    $('.intro').css({ visibility: 'hidden' });
                    $('intro__svg').css({ visibility: 'hidden' });

                    // headerAnimation();
                },
                onStart: function () {
                    $('body').addClass('showHeaderAnim');
                }

            });



        } else {

            if (getCookie('introAnim') == 1) {
                $('.intro').addClass('hide');
                $('.intro').removeClass('show');
                $('body').removeClass('showMenu');
                $('body').addClass('showHeaderAnim');
                //  $('.intro').css('visibility', 'hidden');

            } else {
                $('.intro').addClass('hide2');
                $('.intro').removeClass('show');
                $('body').removeClass('showMenu');
                $('body').addClass('showHeaderAnim');
                //$('.intro').css('visibility', 'hidden');

            }

        }



        //fancybox
        const fcbChck = document.querySelectorAll(".blocks-gallery-item a, .fancybox, .wp-block-image a[href$='.jpg'], .wp-block-image a[href$='.jpeg'], .wp-block-image a[href$='.png']");

        if (fcbChck.length > 0) {
            let scriptF = document.createElement("script");
            scriptF.setAttribute("src", window.location.origin + "/wp-content/themes/wmlogistics/plugins/fancybox/jquery.fancybox.min.js");
            document.body.appendChild(scriptF);
            let cssF = document.createElement("link");
            cssF.setAttribute("rel", 'stylesheet');
            cssF.setAttribute("href", window.location.origin + "/wp-content/themes/wmlogistics/plugins/fancybox/jquery.fancybox.min.css");
            document.body.appendChild(cssF);

            scriptF.addEventListener("load", () => {

                $(".blocks-gallery-item a, .fancybox, .wp-block-image a[href$='.jpg'], .wp-block-image a[href$='.jpeg'], .wp-block-image a[href$='.png']").fancybox({
                    'loop': true,
                    'margin': [44, 0],
                    'gutter': 50,
                    'keyboard': true,
                    'arrows': true,
                    'infobar': false,
                    'toolbar': true,
                    'buttons': ["slideShow", "fullScreen", "close"],
                    'idleTime': 4,
                    'protect': false,
                    'modal': false,
                    'animationEffect': "fade",
                    'animationDuration': 600,
                    'transitionEffect': "fade",
                    'transitionDuration': 800,
                    backFocus: false,
                    thumbs: {
                        autoStart: true, // Display thumbnails on opening
                        hideOnClose: true, // Hide thumbnail grid when closing animation starts
                        parentEl: ".fancybox-container", // Container is injected into this element
                        axis: window.innerWidth > 782 ? "y" : "x" // Vertical (y) or horizontal (x) scrolling
                    }
                });
            });

        }


        if (!isTouchDevice()) {
            document.querySelector('.site').classList.add('smooth');
            scrollObject = smoothScroll("#pageInner");
        } else {
            document.querySelector('.site').classList.remove('smooth');
        }


        if (location.hash != '') {
            if (scrollObject) {
                const hash = location.hash;
                location.hash = '';
                if (document.querySelector(hash)) {
                    const rect = document.querySelector(hash).getClientRects();
                    $('html,body').css({ scrollTop: 0 }, 0);
                    window.setTimeout(() => {
                        if ($(hash)) {
                            $('html,body').css({ scrollTop: 0 }, 0);
                            scrollObject.scroll(rect[0].y - 60);
                        }
                    }, 400);
                }



            }
        }
        document.querySelectorAll('a[href^="#"], a[href$="#contactForm"]').forEach(anchor => {

            if (scrollObject) {
                let id = '';
                if (anchor.getAttribute('href').includes('#contactForm')) {
                    id = 'contactForm';
                } else {
                    id = anchor.getAttribute('href').replace('#', '');
                }
                const target = document.getElementById(id);
                if (target) {
                    const rect = target.getClientRects();
                    anchor.addEventListener('click', (e) => {
                        e.preventDefault();

                        scrollObject.scroll(rect[0].y);
                        return false
                    });
                }
            } else {
                anchor.addEventListener('click', function (e) {
                    e.preventDefault();
                    document.querySelector(this.getAttribute('href')).scrollIntoView({
                        behavior: 'smooth'
                    });
                });
            }
        });

        jQuery('a[href*="' + location.host + '"]:not([href$=".jpg"]):not([href$=".jpeg"]):not([href$=".png"]):not([href$=".gif"]):not([href$=".pdf"]):not([href$=".txt"]):not([href$=".doc"]):not([href$=".docx"]):not([href$=".odt"]):not([href$=".odf"]):not([target="_blank"])')
            .on('click', function (e) {
                if (!e.ctrlKey) {
                    jQuery('.intro').css('visibility', 'visible');
                    jQuery('.intro').addClass('show');
                    jQuery('body').removeClass('showMenu');

                }
            });

        // jQuery('.intro').addClass('hide');
        // jQuery('.intro').removeClass('show');
        // jQuery('body').removeClass('showMenu');



        window.onpageshow = function (event) {
            if (event.persisted) {
                $('.intro').addClass('hide2');
                $('.intro').removeClass('show');
                $('.intro').css('visibility', 'hidden');
                $('body').removeClass('showMenu');
                $('body').addClass('showHeaderAnim');
            }

        };

        $('.gFiles__link').on('click', function (e) {
            e.stopPropagation();
        });


    };
    document.addEventListener("DOMContentLoaded", mainAppWithJquery, false);

})(jQuery);



